import { FontWeight, Heading } from '@lili/lili-frontend-common';
import logoUrl from '@Assets/logos/lili-logo-blue.svg';

export const DirectWelcomeHeader = () => {
  return (
    <div className='flex flex-col w-[500px]'>
      <img className='w-[78px]' src={logoUrl} alt='Lili logo' />

      <Heading.H3 fontWeight={FontWeight.SEMIBOLD} className='text-text-main-primary'>
        Welcome to Lili,
      </Heading.H3>
      <Heading.H8 fontWeight={FontWeight.REGULAR} className='text-text-main-secondary mt-[4px]'>
        Powering your business growth
      </Heading.H8>
    </div>
  );
};
